import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../../../../components/ui/alert-dialog';

interface SingleTarget {
  fileName: string;
  mode: 'single';
}

interface BulkTarget {
  count: number;
  mode: 'bulk';
}

export type DeleteTarget = SingleTarget | BulkTarget;

interface DeleteConfirmDialogProps {
  onCancel: () => void;
  onConfirm: () => void;
  open: boolean;
  target: DeleteTarget | null;
}

const DeleteConfirmDialog = ({ onCancel, onConfirm, open, target }: DeleteConfirmDialogProps) => {
  if (!target) return null;

  const isBulk = target.mode === 'bulk';
  const count = isBulk ? target.count : 1;
  const fileName = !isBulk ? target.fileName : null;

  const title = isBulk ? `¿Eliminar ${count} ${count === 1 ? 'archivo' : 'archivos'}?` : `¿Eliminar "${fileName}"?`;

  const description = isBulk
    ? `Se eliminarán ${count} ${count === 1 ? 'archivo seleccionado' : 'archivos seleccionados'}. Tendrás 10 segundos para recuperarlos.`
    : 'Tendrás 10 segundos para recuperar el archivo si te arrepientes.';

  return (
    <AlertDialog open={open}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="max-w-full [overflow-wrap:anywhere]">{title}</AlertDialogTitle>
          <AlertDialogDescription className="max-w-full [overflow-wrap:anywhere]">{description}</AlertDialogDescription>
        </AlertDialogHeader>

        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel}>Cancelar</AlertDialogCancel>
          <AlertDialogAction
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
            onClick={onConfirm}
          >
            Eliminar
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteConfirmDialog;
